import { Avatar, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'
import { maxWidth } from '@mui/system';
import React from 'react'
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { navbarRoutes } from '../router/navbar-routes';

import { customStyles } from '../styles';
import { NavbarItem } from './NavbarItem';


const style = {
   position: 'fixed',
   left: '50%',
   bottom: 0,
   transform: 'translateX(-50%)',
   backgroundColor: customStyles.colors.backgroundColor,
   width: '100%',
   zIndex: 1
}
export const Navbar = () => {
   const dispatch = useDispatch()

   const { containers: { large } } = customStyles
  return (
   <List sx={{ width: '100%', maxWidth: large, display: 'flex', justifyContent: 'center' }} style={ style } className="mobile__menu">
      {
         navbarRoutes.map(item => (
            <NavbarItem item={ item } key={ item.title }  />
         ))
      }
   </List>
   )
}
